module.exports = __webpack_public_path__ + "files/ruckly.ddf2cd0b87074e6cff2e84fd6c39019b.pdf";